$(document).ready(function () {
    let compareCount = 0;
    let selectedProducts = [];
    const maxCompareItems = getMaxCompareItems(); // Get max comparison slots

    // Load saved data on page load
    loadSavedData();
console.log("selectedProducts: " + selectedProducts.length);
    updateCompareBar();
    updateAddedProducts();
    
    // Function to retrieve data from localStorage
    function loadSavedData() {
        const savedProducts = localStorage.getItem('selectedProducts');
        if (savedProducts) {
            selectedProducts = JSON.parse(savedProducts);
            compareCount = selectedProducts.length;
        }
    }

    // Function to save data to localStorage
    function saveData() {
        localStorage.setItem('selectedProducts', JSON.stringify(selectedProducts));
    }

    // Function to clear saved data from localStorage
    function clearSavedData() {
        localStorage.removeItem('selectedProducts');
    }

    function getMaxCompareItems() {
        return $(window).width() > 768 ? 3 : 2; // 3 for desktop, 2 for mobile
    }

    // Function to update the compare bar
    function updateCompareBar() {
        const $compareTitles = $('#comparison-titles');
        $compareTitles.empty(); // Clear the current list       

        if (selectedProducts.length > 0) {
            $('#comparison-bar').show(); // Show the compare bar

            selectedProducts.forEach(product => {
                const $productItem = $(`
                    <div class="w-compare w-compare-item">
                        <img src="${product.productImage}" alt="${product.title}" class="w-compare-img">
                        <div class="w-product-title">${product.title}</div>
                        <a href="javascript:;" class="w-compare-remove"><img src="https://cdn.shopify.com/s/files/1/0964/5103/5454/files/close-button_b2649814-1d26-461b-883d-952e22724b43.svg?v=1771917757" title="Remove item"></a>
                    </div>
                `);
                $productItem.find('.w-compare-remove').data('title', product.title);
                $compareTitles.append($productItem);
            });

            // Add placeholders for remaining slots
            for (let i = selectedProducts.length; i < maxCompareItems; i++) {
                const $placeholderItem = $(`
                    <div class="w-compare w-compare-item">
                        <div class="w-compare-add"></div>
                    </div>
                `);
                $compareTitles.append($placeholderItem);
            }

            updateComparisonButtonText(selectedProducts.length);
        } else {
            $('#comparison-bar').hide();
        }
    }   

    function updateAddedProducts(){
        if (selectedProducts.length > 0) {
            selectedProducts.forEach(product => {
                $("#compare-pro-"+ product.id).prop("checked", true);
            });
        }
    }
    
    function updateComparisonButtonText(selectedCount) {       
        const buttonText = selectedCount < 2
            ? "Compare"
            : `Compare ${selectedCount}/${maxCompareItems}`;

        $("#show-comparison").text(buttonText);

        if (selectedCount < 2) {
            $("#show-comparison").attr("disabled", "disabled");
        } else {
            $("#show-comparison").removeAttr("disabled");
        }
    }

    function isMobile() {
        return window.innerWidth <= 768;
    }
    // Event listener for the checkbox
    $(document).on('change', '.add-to-compare', function () {
        const maxCompareItems = getMaxCompareItems();
        // const id = $(this).parent("div").prev('.product-info').find('.product-id').val();
        // const features = $(this).parent("div").prev('.product-info').find('.product-features').val();
        // const productUrl = $(this).parent("div").prev('.product-info').find('.product-url').val();
        // const title = $(this).parent("div").prev('.product-info').find('.product-title').html();
        // const productImage =$(this).parent("div").prev('.product-info').find('.product-img').attr("src");    
        
        const id =  $(this).closest('.snize-product').find('.product-id').val();
        const features =  $(this).closest('.snize-product').find('.product-features').val();
        const productUrl =  $(this).closest('.snize-product').find('.product-url').val();
        const title = "Innova " + $(this).closest('.snize-product').find('.snize-sku').text().trim();
        const productImage =$(this).closest('.snize-product').find('.snize-item-image').attr("src");       
        const productData = {id, features, title, productImage, productUrl };

        if ($(this).is(':checked')) {
            if (compareCount < maxCompareItems) {
                compareCount++;
                selectedProducts.push(productData);
                $(this).next('label').find('span').text('Added to Compare');
            } else {
                $(this).prop('checked', false); // Revert the checkbox if limit exceeded
                alert(`Please compare up to ${maxCompareItems} items at a time.`);
            }
        } else {
            compareCount--;
            const index = selectedProducts.findIndex(product => product.title === title);
            if (index > -1) selectedProducts.splice(index, 1); // Remove product object from the array
            $(this).next('label').find('span').text('Add to Compare'); // Revert label text
        }

        saveData(); // Save updated data to localStorage
        updateCompareBar();
    });

    $(document).on('click', '.w-compare-remove', function () {
        const title = $(this).data('title');
        const index = selectedProducts.findIndex(product => product.title === title);
        if (index > -1) selectedProducts.splice(index, 1); // Remove product object from array

        compareCount--; // Decrement the count

        $('.product-info').each(function () {
            const $checkbox = $(this).next('div').find('.add-to-compare');
            const checkboxTitle = $(this).find('.product-title').html();
            if (checkboxTitle === title) {
                $checkbox.prop('checked', false).next('label').find('span').text('Add to Compare'); // Revert label text
            }
        });

        saveData(); // Save updated data to localStorage
        updateCompareBar(); // Update the compare bar
    });

    $(document).on('click', '#clear-all-comparison', function () {
        compareCount = 0;
        selectedProducts.length = 0; // Clear all selected products

        $('.add-to-compare').prop('checked', false).next('label').find('span').text('Add to Compare');

        clearSavedData(); // Clear data from localStorage
        updateCompareBar();
    });

    $("#show-comparison").click(function () {
        if (selectedProducts.length < 2) {
            alert("Please select at least 2 products for comparison.");
            return;
        }
        if (selectedProducts.length > maxCompareItems) {
            alert(`You can compare up to ${maxCompareItems} products only.`);
            return;
        }
        renderComparisonChart(selectedProducts);

        $("#modal-product-comparison").modal('show');
    });

    function renderComparisonChart(selectedProducts){        
        var outputHtml = selectedProducts.length > 2 ? '<table class="table w-tbl-comparison">' :  '<table class="table w-tbl-comparison w-two-row">';
        //render product name
        outputHtml += '<thead><tr align="center">';
        selectedProducts.forEach(product => {
            outputHtml += '<th><h2 class="w-product-name">'+ product.title +'</h2></th>';
        });
        outputHtml += '</tr></thead>';
        outputHtml += '<tbody>';
        //render product image
        outputHtml += '<tr align="center">';
        selectedProducts.forEach(product => {
            outputHtml += '<td><img src="'+ product.productImage +'" class="w-img-fluid" alt="'+ product.title +'"><br><a href="'+ product.productUrl +'" class="w-learn-more">Learn more</a></td>';
        });
        //render comparison chart
        outputHtml += '</tr>';
        outputHtml += '<tr><td colspan="3"><div class="w-tbl-title">Essential Features</div></td></tr>';
        outputHtml += '<tr>';
        selectedProducts.forEach(product => {
            outputHtml += renderEssentialComparisonChart(product.features);
        });        
        outputHtml += '</tr>';
        outputHtml += '<tr><td colspan="3"><div class="w-tbl-title">Advanced Features</div></td></tr>';
        outputHtml += '<tr>';
        selectedProducts.forEach(product => {
            outputHtml += renderAdvancedComparisonChart(product.features);
        });
        outputHtml += '</tr>';
        outputHtml += '</tbody>';
        outputHtml += '</table>';

        $("#comparisonResults").html(outputHtml);
        $('[data-bs-toggle="popover"]').popover({
            container: 'body',
            trigger: 'focus',
            html: true 
        });
    }

    function renderEssentialComparisonChart(toolFeaturesJson){                        
        var autolink_tooltip = 'Auto-Relink automatically re-scans the vehicle at regular intervals, ensuring readiness monitors and key parameters are updated for SMOG testing and emissions compliance.';
        var codepriority_tooltip = 'Code Priority refers to identifying the main fault code responsible for triggering your dashboard light. In many cases, resolving the primary fault code can also address related secondary codes that appear afterward.';
        var ten_obd_modes_tooltip = '<strong>Mode 01</strong> - I/M Readiness Status/Live Data Mode (PIDs)<br><strong>Mode 02</strong> - Freeze Frame Data<br><strong>Mode 03</strong> - Emission Related DTCs<br><strong>Mode 04</strong> - Erase DTCs<br><strong>Mode 05</strong> - Request O2 test results<br><strong>Mode 06</strong> - I/M Monitor Tests/Monitoring test results and parameters<br><strong>Mode 07</strong> - Two Trip Pending Diagnostic Trouble Code<br><strong>Mode 08</strong> - Request control of Onboard Component<br><strong>Mode 09</strong> - Request vehicle info<br><strong>Mode 10</strong> or <strong>Mode 0a</strong> - Permanent DTC';
        var eight_obd_modes_tooltip = '<strong>Mode 01</strong> - I/M Readiness Status/Live Data Mode (PIDs)<br><strong>Mode 02</strong> - Freeze Frame Data<br><strong>Mode 03</strong> - Emission Related DTCs<br><strong>Mode 04</strong> - Erase DTCs<br><strong>Mode 05</strong> - Request O2 test results<br><strong>Mode 07</strong> - Two Trip Pending Diagnostic Trouble Code<br><strong>Mode 09</strong> - Request vehicle info<br><strong>Mode 10</strong> or <strong>Mode 0a</strong> - Permanent DTC';
        var drive_cycle_tooltip = 'Drive Cycle Procedures refers to the ability of guiding you through each specific driving step to reset monitors for SMOG testing with real time instructions.';

        var tool_features = JSON.parse(toolFeaturesJson);
        var ret = '<td>';      
        ret += '<ul class="w-list">';
        if(tool_features.checkEngine != undefined && tool_features.checkEngine != null && tool_features.checkEngine !=  ''){               
            ret += tool_features.checkEngine.toLowerCase() == "yes"? '<li>Check Engine</li>' : '<li class="unchecked">Check Engine</li>';
        }
        if(tool_features.smogEmissions != undefined && tool_features.smogEmissions != null && tool_features.smogEmissions != ''){               
            ret += tool_features.smogEmissions.toLowerCase() == "yes"? '<li>SMOG / Emissions</li>' : '<li class="unchecked">SMOG / Emissions</li>';
        }
        // if(tool_features.mode6FreezeFrame != undefined && tool_features.mode6FreezeFrame != null && tool_features.mode6FreezeFrame != ''){               
        //     ret += tool_features.mode6FreezeFrame.toLowerCase() == "yes"? '<li>Mode 6 / Freeze Frame</li>' : '<li class="unchecked">Mode 6 / Freeze Frame</li>';
        // }   
        if(tool_features.autoReLink != undefined && tool_features.autoReLink != null && tool_features.autoReLink != ''){               
            ret += tool_features.autoReLink.toLowerCase() == "yes"? 
            '<li><span class="w-popover-wrapper">Auto Re-Link <a tabindex="0" data-bs-container="body" data-bs-toggle="popover" data-bs-trigger="focus" data-bs-placement="top" data-bs-content="'+ autolink_tooltip +'" class="w-popover"><img src="//www.innova.com/cdn/shop/t/28/assets/inv2-quest.svg" height="auto" alt="" width="18"></a></span></li>' 
            :'<li class="unchecked">Auto Re-Link</li>';
        }
        if(tool_features.codePriority != undefined && tool_features.codePriority != null && tool_features.codePriority !=''){               
            ret += tool_features.codePriority.toLowerCase() == "yes"? 
            '<li><span class="w-popover-wrapper">Code Priority <a tabindex="0" data-bs-container="body" data-bs-toggle="popover" data-bs-trigger="focus" data-bs-placement="top" data-bs-content="'+ codepriority_tooltip +'" class="w-popover"><img src="//www.innova.com/cdn/shop/t/28/assets/inv2-quest.svg" height="auto" alt="" width="18"></a></span></li>'
            :'<li class="unchecked">Code Priority</li>';
        }
        if(tool_features.codeSeverity != undefined && tool_features.codeSeverity != null && tool_features.codeSeverity != ''){               
            ret += tool_features.codeSeverity.toLowerCase() == "yes"? '<li>Code Severity</li>' : '<li class="unchecked">Code Severity</li>';
        }
        if(tool_features.batteryChargingSystemTest != undefined && tool_features.batteryChargingSystemTest != null && tool_features.batteryChargingSystemTest != ''){               
            ret += tool_features.batteryChargingSystemTest.toLowerCase() == "yes"? '<li>Battery & Charging System Test</li>' : '<li class="unchecked">Battery & Charging System Test</li>';
        }
        if(tool_features.all10ObdModes != undefined && tool_features.all10ObdModes != null && tool_features.all10ObdModes != ''){               
            ret += tool_features.all10ObdModes.toLowerCase() == "yes"? '<li><span class="w-popover-wrapper">All 10 OBD Modes <a tabindex="0" data-bs-container="body" data-bs-toggle="popover" data-bs-trigger="focus" data-bs-placement="top" data-bs-content="'+ ten_obd_modes_tooltip +'" class="w-popover"><img src="//www.innova.com/cdn/shop/t/28/assets/inv2-quest.svg" height="auto" alt="" width="18"></a></span></li>' : '<li class="unchecked">All 10 OBD Modes</li>';
        }            
        if(tool_features.all8ObdModes != undefined && tool_features.all8ObdModes != null && tool_features.all8ObdModes != ''){               
            ret += tool_features.all8ObdModes.toLowerCase() == "yes"? '<li><span class="w-popover-wrapper">8 OBD Modes <a tabindex="0" data-bs-container="body" data-bs-toggle="popover" data-bs-trigger="focus" data-bs-placement="top" data-bs-content="'+ eight_obd_modes_tooltip +'" class="w-popover"><img src="//www.innova.com/cdn/shop/t/28/assets/inv2-quest.svg" height="auto" alt="" width="18"></a></span></li>' : '<li class="unchecked">8 OBD Modes</li>';
        }
        if(tool_features.driveCycleProcedures != undefined && tool_features.driveCycleProcedures != null && tool_features.driveCycleProcedures != ''){               
            ret += tool_features.driveCycleProcedures.toLowerCase() == "yes"? '<li><span class="w-popover-wrapper">Drive Cycle Procedures <a tabindex="0" data-bs-container="body" data-bs-toggle="popover" data-bs-trigger="focus" data-bs-placement="top" data-bs-content="'+ drive_cycle_tooltip +'" class="w-popover"><img src="//www.innova.com/cdn/shop/t/28/assets/inv2-quest.svg" height="auto" alt="" width="18"></a></span></li>' : '<li class="unchecked">Drive Cycle Procedures</li>';
        }
            if(tool_features.liveDataGraphing != undefined && tool_features.liveDataGraphing !=null && tool_features.liveDataGraphing != ''){               
            ret += tool_features.liveDataGraphing.toLowerCase() == "yes"? '<li>OBD2 Live Data Graphing</li>' : '<li class="unchecked">OBD2 Live Data Graphing</li>';
        }
        if(tool_features.liveDataGraphingRecordPlayback != undefined && tool_features.liveDataGraphingRecordPlayback != null && tool_features.liveDataGraphingRecordPlayback != ''){               
            ret += tool_features.liveDataGraphingRecordPlayback.toLowerCase() == "yes"? '<li>OBD2 Live Data Record / Playback</li>' : '<li class="unchecked">OBD2 Live Data Record / Playback</li>';
        }
        if(tool_features.absBrakeCodes != undefined && tool_features.absBrakeCodes != null && tool_features.absBrakeCodes != ''){               
            ret += tool_features.absBrakeCodes.toLowerCase() == "yes"? '<li>ABS Brake Codes</li>' : '<li class="unchecked">ABS Brake Codes</li>';
        }
        if(tool_features.srsAirbagCodes != undefined && tool_features.srsAirbagCodes != null && tool_features.srsAirbagCodes != ''){               
            ret += tool_features.srsAirbagCodes.toLowerCase() == "yes"? '<li>SRS Airbag Codes</li>' : '<li class="unchecked">SRS Airbag Codes</li>';
        }
        //  if(tool_features.obdLiveData != undefined && tool_features.obdLiveData !=  null && tool_features.obdLiveData != ''){               
        //     ret += tool_features.obdLiveData.toLowerCase() == "yes"? '<li>OBD Live Data</li>' : '<li class="unchecked">OBD Live Data</li>';
        // }           
        // if(tool_features.oilLightReset != undefined && tool_features.oilLightReset != null && tool_features.oilLightReset != ''){               
        //     ret += tool_features.oilLightReset.toLowerCase() == "yes"? '<li>Oil Light Reset</li>' : '<li class="unchecked">Oil Light Reset</li>';
        // } 
        if(tool_features.allSystemScan != undefined && tool_features.allSystemScan != null && tool_features.allSystemScan != ''){               
            ret += tool_features.allSystemScan.toLowerCase() == "yes"? '<li>All System Scan</li>' : '<li class="unchecked">All System Scan</li>';
        }
        if(tool_features.readsTPMSTirePressure != undefined && tool_features.readsTPMSTirePressure != null  && tool_features.readsTPMSTirePressure != ''){               
            ret += tool_features.readsTPMSTirePressure.toLowerCase() == "yes"? '<li>Reads TPMS/Tire Pressure</li>' : '<li class="unchecked">Reads TPMS/Tire Pressure</li>';
        }
        ret += '</ul>';
        ret += '</td>';       
        
        return ret;
    }

    function renderAdvancedComparisonChart(toolFeaturesJson){                        
        var autolink_tooltip = 'Auto-Relink automatically re-scans the vehicle at regular intervals, ensuring readiness monitors and key parameters are updated for SMOG testing and emissions compliance.';
        var codepriority_tooltip = 'Code Priority refers to identifying the main fault code responsible for triggering your dashboard light. In many cases, resolving the primary fault code can also address related secondary codes that appear afterward.';
        var ten_obd_modes_tooltip = '<strong>Mode 01</strong> - I/M Readiness Status/Live Data Mode (PIDs)<br><strong>Mode 02</strong> - Freeze Frame Data<br><strong>Mode 03</strong> - Emission Related DTCs<br><strong>Mode 04</strong> - Erase DTCs<br><strong>Mode 05</strong> - Request O2 test results<br><strong>Mode 06</strong> - I/M Monitor Tests/Monitoring test results and parameters<br><strong>Mode 07</strong> - Two Trip Pending Diagnostic Trouble Code<br><strong>Mode 08</strong> - Request control of Onboard Component<br><strong>Mode 09</strong> - Request vehicle info<br><strong>Mode 10</strong> or <strong>Mode 0a</strong> - Permanent DTC';
        var eight_obd_modes_tooltip = '<strong>Mode 01</strong> - I/M Readiness Status/Live Data Mode (PIDs)<br><strong>Mode 02</strong> - Freeze Frame Data<br><strong>Mode 03</strong> - Emission Related DTCs<br><strong>Mode 04</strong> - Erase DTCs<br><strong>Mode 05</strong> - Request O2 test results<br><strong>Mode 07</strong> - Two Trip Pending Diagnostic Trouble Code<br><strong>Mode 09</strong> - Request vehicle info<br><strong>Mode 10</strong> or <strong>Mode 0a</strong> - Permanent DTC';
        var drive_cycle_tooltip = 'Drive Cycle Procedures refers to the ability of guiding you through each specific driving step to reset monitors for SMOG testing with real time instructions.';

        var tool_features = JSON.parse(toolFeaturesJson);
        var ret = '<td>'; 
        ret += '<ul class="w-list">';
        //  if(tool_features.batteryBmsResetInitialization != undefined){               
        //     ret += tool_features.batteryBmsResetInitialization.toLowerCase() == "yes"? '<li>Battery / BMS Reset & Initialization</li>' : '<li class="unchecked">Battery / BMS Reset & Initialization</li>';
        // }
        if(tool_features.readHybridBatteryCellVoltage != undefined && tool_features.readHybridBatteryCellVoltage != null && tool_features.readHybridBatteryCellVoltage != ''){               
            ret += tool_features.readHybridBatteryCellVoltage.toLowerCase() == "yes"? '<li>Read Hybrid Battery Cell Voltage</li>' : '<li class="unchecked">Read Hybrid Battery Cell Voltage</li>';
        }
        if(tool_features.serviceChecks != undefined && tool_features.serviceChecks != null && tool_features.serviceChecks != ''){
            if(Array.isArray(tool_features.serviceChecks)){//&& tool_features.serviceChecks.toLowerCase() != "no"
                ret += '<li><div class="w-dropdown dropdown"><a class="dropdown-toggle" href="#;" role="button" data-bs-toggle="dropdown" aria-expanded="false">Service Checks</a>';
                ret +='<ul class="dropdown-menu">';
                for(var item in tool_features.serviceChecks){
                    ret += '<li><a class="dropdown-item" href="#;">'+ tool_features.serviceChecks[item] +'</a></li>';
                }
                ret += '</ul></div></li>';
            }else{
                ret += tool_features.serviceChecks.toLowerCase() == "yes"? '<li>Service Checks</li>' : '<li class="unchecked">Service Checks</li>';
            }
        }
        if(tool_features.warningLights != undefined && tool_features.warningLights != null && tool_features.warningLights != ''){  
            if(Array.isArray(tool_features.warningLights)){
                ret += '<li><div class="w-dropdown dropdown"><a class="dropdown-toggle" href="#;" role="button" data-bs-toggle="dropdown" aria-expanded="false">Warning Lights</a>';
                ret +='<ul class="dropdown-menu">';
                for(var item in tool_features.warningLights){
                    ret += '<li><a class="dropdown-item" href="#;">'+ tool_features.warningLights[item] +'</a></li>';
                }
                ret += '</ul></div></li>';
            }else{
                ret += tool_features.warningLights.toLowerCase() == "yes"? '<li>Warning Lights</li>' : '<li class="unchecked">Warning Lights</li>';
            }
        }
        if(tool_features.oemLiveData != undefined && tool_features.oemLiveData != null && tool_features.oemLiveData != ''){ 
            if(Array.isArray(tool_features.oemLiveData)){
                ret += '<li><div class="w-dropdown dropdown"><a class="dropdown-toggle" href="#;" role="button" data-bs-toggle="dropdown" aria-expanded="false">OEM Live Data</a>';
                ret +='<ul class="dropdown-menu">';
                for(var item in tool_features.oemLiveData){
                    ret += '<li><a class="dropdown-item" href="#;">'+ tool_features.oemLiveData[item] +'</a></li>';
                }
                ret += '</select></div></li>';
            }else{
                ret += tool_features.oemLiveData.toLowerCase() == "yes"? '<li>OEM Live Data</li>' : '<li class="unchecked">OEM Live Data</li>';
            }
        }
        if(tool_features.bidirectionalSystemTest != undefined && tool_features.bidirectionalSystemTest != null && tool_features.bidirectionalSystemTest != ''){  
            if(Array.isArray(tool_features.bidirectionalSystemTest)){
                ret += '<li><div class="w-dropdown dropdown"><a class="dropdown-toggle" href="#;" role="button" data-bs-toggle="dropdown" aria-expanded="false">Bidirectional System Test</a>';
                ret +='<ul class="dropdown-menu">';
                for(var item in tool_features.bidirectionalSystemTest){
                    ret += '<li><a class="dropdown-item" href="#;">'+ tool_features.bidirectionalSystemTest[item] +'</a></li>';
                }
                ret += '</select></div></li>';
            }else{
                ret += tool_features.bidirectionalSystemTest.toLowerCase() == "yes"? '<li>Bidirectional System Test</li>' : '<li class="unchecked">Bidirectional System Test</li>';
            }
        }
        if(tool_features.specialFunctionsRoutinesCalibrations != undefined && tool_features.specialFunctionsRoutinesCalibrations != null && tool_features.specialFunctionsRoutinesCalibrations != ''){ 
            if(Array.isArray(tool_features.specialFunctionsRoutinesCalibrations)){
                ret += '<li><div class="w-dropdown dropdown"><a class="dropdown-toggle" href="#;" role="button" data-bs-toggle="dropdown" aria-expanded="false">Special Functions, Routines, and Calibrations</a>';
                ret +='<ul class="dropdown-menu">';
                for(var item in tool_features.specialFunctionsRoutinesCalibrations){
                    ret += '<li><a class="dropdown-item" href="#;">'+ tool_features.specialFunctionsRoutinesCalibrations[item] +'</a></li>';
                }
                ret += '</select></div></li>';
            }else{
                ret += tool_features.specialFunctionsRoutinesCalibrations.toLowerCase() == "yes"? '<li>Special Functions, Routines, and Calibrations</li>' : '<li class="unchecked">Special Functions, Routines, and Calibrations</li>';
            }
        }
        if(tool_features.obd1CoverageRequiresObd1Connector != undefined && tool_features.obd1CoverageRequiresObd1Connector != null && tool_features.obd1CoverageRequiresObd1Connector !=''){               
            ret += tool_features.obd1CoverageRequiresObd1Connector.toLowerCase() == "yes"? '<li>OBD1 Coverage <p><small>(Requires OBD1 Connector)</small></p></li>' : '<li class="unchecked">OBD1 Coverage <p><small>(Requires OBD1 Connector)</small></p></li>';
        }
        if(tool_features.hdTruckCoverage != undefined && tool_features.hdTruckCoverage != null && tool_features.hdTruckCoverage != ''){               
            ret += tool_features.hdTruckCoverage.toLowerCase() == "yes"? '<li>HD Truck Coverage <p><small>Requires HD Connector</small></p></li>' : '<li class="unchecked">HD Truck Coverage <p><small>Requires HD Connector</small></p></li>';
        }
        if(tool_features.compatibleWithRs2App != undefined && tool_features.compatibleWithRs2App != null && tool_features.compatibleWithRs2App !=''){               
            ret += tool_features.compatibleWithRs2App.toLowerCase() == "yes"? '<li>Compatible with RS2 App</li>' : '<li class="unchecked">Compatible with RS2 App</li>';
        }
        if(tool_features.workshopTools != undefined && tool_features.workshopTools != null && tool_features.workshopTools != ''){
            if(Array.isArray(tool_features.workshopTools)){
                ret += '<li><div class="w-dropdown dropdown"><a class="dropdown-toggle" href="#;" role="button" data-bs-toggle="dropdown" aria-expanded="false"> '+ tool_features.workshopTools.length +' Workshop Tools</a>';
                ret +='<ul class="dropdown-menu">';
                for(var item in tool_features.workshopTools){
                    ret += '<li><a class="dropdown-item" href="#;">'+ tool_features.workshopTools[item] +'</a></li>';
                }
                ret += '</select></div></li>';
            }else{
                ret += tool_features.workshopTools.toLowerCase() == "yes"? '<li>Workshop Tools</li>' : '<li class="unchecked">Workshop Tools</li>';
            }
        }
        if(tool_features.secureGatewayForFCAvehicles != undefined && tool_features.secureGatewayForFCAvehicles != null && tool_features.secureGatewayForFCAvehicles !=''){               
            ret += tool_features.secureGatewayForFCAvehicles.toLowerCase() == "yes"? '<li>Secure Gateway For FCA Vehicles</li>' : '<li class="unchecked">Secure Gateway For FCA Vehicles</li>';
        }
        
        // if(tool_features.absBleeding != undefined){               
        //     ret += tool_features.absBleeding.toLowerCase() == "yes"? '<li>ABS Bleeding</li>' : '<li class="unchecked">ABS Bleeding</li>';
        // }
        // if(tool_features.epbReset != undefined){               
        //     ret += tool_features.epbReset.toLowerCase() == "yes"? '<li>EPB Reset</li>' : '<li class="unchecked">EPB Reset</li>';
        // }
        // if(tool_features.readTpms != undefined){               
        //     ret += tool_features.readTpms.toLowerCase() == "yes"? '<li>Read TPMS</li>' : '<li class="unchecked">Read TPMS</li>';
        // }
        // if(tool_features.readTransmissionTemperature != undefined){               
        //     ret += tool_features.readTransmissionTemperature.toLowerCase() == "yes"? '<li>Read Transmission Temperature</li>' : '<li class="unchecked">Read Transmission Temperature</li>';
        // }
        // if(tool_features.brakePadLife != undefined){               
        //     ret += tool_features.brakePadLife.toLowerCase() == "yes"? '<li>Brake Pad Life</li>' : '<li class="unchecked">Brake Pad Life</li>';
        // }
        // if(tool_features.oemLiveDataEngineTransTpmsAbsSrs != undefined){               
        //     ret += tool_features.oemLiveDataEngineTransTpmsAbsSrs.toLowerCase() == "yes"? '<li>OEM Live Data: Engine, Trans, TPMS, ABS, SRS</li>' : '<li class="unchecked">OEM Live Data: Engine, Trans, TPMS, ABS, SRS</li>';
        // } 
        ret += '</ul>';
        ret += '</td>'; 

        return ret;
    }

    $(window).on('resize', function () {
        const maxCompareItems = getMaxCompareItems();
        if (compareCount > maxCompareItems) {
            alert(`Please compare up to ${maxCompareItems} items at a time.`);
            $('.add-to-compare:checked').slice(maxCompareItems).prop('checked', false).next('label').find('span').text('Add to Compare');
            selectedProducts.splice(maxCompareItems); // Trim the array to the new max
            compareCount = selectedProducts.length;
            saveData(); // Save updated data to localStorage
            updateCompareBar();
        }
    });
});